import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";
import ReactTimeout from "react-timeout";

class SendEventButton extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      submitting: false,
    };

    this.validated = this.validated.bind(this);
  }

  validated(values) {
    return this.props.editFunction(values);
  }

  render() {
    const actionButtonClassNames = classNames({
      invisible: !this.props.visible,
      "send-event-button": true,
    });

    const actions = [];
    if (this.props.allowSubmission) {
      actions.push({
        id: 1,
        disabled: this.props.submitting || this.state.submitting,
        text: <FormattedMessage id="common.confirm" />,
        action: this.validate,
      });
    }
    return (
      <Button
        ref="action"
        className={actionButtonClassNames}
        bsStyle={"primary"}
        bsSize={"xsmall"}
        onClick={this.validated}
        disabled={this.props.disabled}
      >
        {this.props.label}
      </Button>
    );
  }
}

SendEventButton.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object,
  disabled: PropTypes.bool,
  editFunction: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  props: PropTypes.object,
  readOnly: PropTypes.bool,
  submitting: PropTypes.bool,
  visible: PropTypes.bool,
  allowSubmission: PropTypes.bool,
};

SendEventButton.defaultProps = {
  allowSubmission: true,
  submitting: false,
  visible: true,
};

function mapStateToProps(state) {
  return {
    submitting: state.data.submitting,
  };
}

const ConnectedSendEventButton = connect(mapStateToProps)(SendEventButton);
const WrappedSendEventButton = ReactTimeout(ConnectedSendEventButton);

export default WrappedSendEventButton;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/SendEventButton.js